import { render } from "./Table.vue?vue&type=template&id=2d69ead5&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/IrrigationWaterData/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d69ead5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d69ead5', __exports__)) {
    console.log('reload')
    api.reload('2d69ead5', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=2d69ead5&ts=true", () => {
    console.log('re-render')
    api.rerender('2d69ead5', render)
  })

}


export default __exports__